import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { GlobalConstants } from '../common/GlobalConstants ';

@Component({
  selector: 'app-access-log-list',
  templateUrl: './access-log-list.component.html',
  styleUrls: ['./access-log-list.component.css']
})
export class AccessLogListComponent extends BaseListCtl{

  datePickerConfig : Partial<BsDatepickerConfig>;

  constructor(public locator: ServiceLocatorService,private http: HttpClient, public route: ActivatedRoute) {
    super(locator.endpoints.ACCESSLOG,locator,route);
    let sid = localStorage.getItem('sessionId');
        
    
    this.datePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: true,
        
        maxDate: new Date(),
        dateInputFormat: 'YYYY/MM/DD'
      });


  }
    excelData :any;
    downloadFile(): void {
      this.download()
        .subscribe(blob => saveAs(blob, 'AccessList.xlsx'));
    }

    download(): Observable<Blob> {
      let _self = this;
      let sid = localStorage.getItem( GlobalConstants.getKey('sessionId'));
      console.log(sid+'siddd' + this.form.searchParams);
      let url =  _self.locator.endpoints.ACCESSLOG+"/exportAccessLogList"+ ";jsessionid=" + sid;
      return this.http.post(url, this.form.searchParams, {
        responseType: 'blob'
      });

    }

  populateForm(form, data) {
    form.id = data.id;
    form.status = data.status;
    form.unitId=data.unitId;
    form.unitName=data.unitName;
    form.gateId=data.gateId;
    form.gateName=data.gateName;
    form.dateTime=data.dateTime;
    form.date=data.date;
    form.endTime = data.endTime;
    form.userId=data.userId;
    form.userName=data.userName;
    form.latPos=data.latPos;
    form.lonPos=data.lonPos;
    form.imei=data.imei;
    form.accessType=data.accessType;
    form.userStatus = data.userStatus;
    console.log('----->',data);
  }

}
